const sectionTrustBadgeCss = `
[data-type='section-trust-badge'] [data-attribute='trust-badge-section'] {
  padding-top: var(--padding-top-desktop, 4px);
  padding-bottom: var(--padding-bottom-desktop, 4px);
  background-color: var(--background-color, #ffffff);
}

[data-type='section-trust-badge'] .trust-badge-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px;
  border: 1px solid var(--border-color, #e0e0e0);
  background-color: var(--container-background-color, #ffffff);
  border-radius: 4px;
}

[data-type='section-trust-badge'] .trust-badge-score {
  background-color: var(--trust-badge-score-bg-color, #f5f5f5);
  color: var(--trust-badge-score-color, #000000);
  height: -webkit-fill-available;
  width: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border-radius: 4px;
  padding: 16px;
  white-space: pre-wrap;
  word-break: break-all;
}

[data-type='section-trust-badge'] .trust-badge-score h1,
[data-type='section-trust-badge'] .trust-badge-score h2,
[data-type='section-trust-badge'] .trust-badge-score h3 {
  font-size: 36px;
  line-height: 36px;
  margin: 0 0 6px 0 !important;
}

[data-type='section-trust-badge'] .trust-badge-score h1:last-child,
[data-type='section-trust-badge'] .trust-badge-score h2:last-child,
[data-type='section-trust-badge'] .trust-badge-score h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-trust-badge'] .trust-badge-score p {
  font-size: 18px;
  line-height: 18px;
  margin: 0 0 4px 0 !important;
}

[data-type='section-trust-badge'] .trust-badge-score p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-trust-badge'] .trust-badge-info {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

[data-type='section-trust-badge'] .trust-badge-brand h1,
[data-type='section-trust-badge'] .trust-badge-brand h2,
[data-type='section-trust-badge'] .trust-badge-brand h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 8px 0 !important;
}

[data-type='section-trust-badge'] .trust-badge-brand h1:last-child,
[data-type='section-trust-badge'] .trust-badge-brand h2:last-child,
[data-type='section-trust-badge'] .trust-badge-brand h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-trust-badge'] .trust-badge-brand p {
  font-size: 14px;
  line-height: normal;
  margin: 0 0 6px 0 !important;
}

[data-type='section-trust-badge'] .trust-badge-brand p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-trust-badge'] .trust-badge-images {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

[data-type='section-trust-badge'] .trust-badge-images .trust-badge-image-1 {
  max-width: 130px;
}

[data-type='section-trust-badge'] .trust-badge-images .trust-badge-image-2 {
  max-width: 170px;
}

[data-type='section-trust-badge'] .trust-badge-images .trust-badge-image-3 {
  max-width: 180px;
}

@container (max-width: 768px) {
  [data-type='section-trust-badge'] [data-attribute='trust-badge-section'] {
    padding-top: var(--padding-top-mobile, 4px);
    padding-bottom: var(--padding-bottom-mobile, 4px);
  }

  [data-type='section-trust-badge'] .trust-badge-card {
    padding: 12px;
  }

  [data-type='section-trust-badge'] .trust-badge-score {
    width: 130px;
    padding: 12px;
  }

  [data-type='section-trust-badge'] .trust-badge-score h1,
  [data-type='section-trust-badge'] .trust-badge-score h2,
  [data-type='section-trust-badge'] .trust-badge-score h3 {
    font-size: 32px;
  }

  [data-type='section-trust-badge'] .trust-badge-score p {
    font-size: 16px;
  }

  [data-type='section-trust-badge'] .trust-badge-brand h1,
  [data-type='section-trust-badge'] .trust-badge-brand h2,
  [data-type='section-trust-badge'] .trust-badge-brand h3 {
    font-size: 20px;
  }

  [data-type='section-trust-badge'] .trust-badge-brand p {
    font-size: 12px;
  }
}
`;
export default sectionTrustBadgeCss;
